export default "__VITE_ASSET__e82VgkVL__"